const TAG_COLORS = [
  '#3B82F6', // bright blue
  '#06B6D4', // bright cyan
  '#10B981', // bright green
  '#F59E0B', // bright orange
  '#8B5CF6', // bright purple
  '#EC4899', // bright pink
  '#EF4444', // bright red
  '#F97316', // bright orange-red
  '#6366F1', // bright indigo
  '#14B8A6', // bright teal
]

function hashString(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32-bit integer
  }
  return Math.abs(hash)
}

export function getTagColor(tagName: string): string {
  const hash = hashString(tagName)
  return TAG_COLORS[hash % TAG_COLORS.length]
}
